import React from 'react';
import EmptyState from '../components/ui/EmptyState';

export default function NotFound() {
  return (
    <div style={{ padding: '2rem 1.5rem' }}>
      <EmptyState
        icone="safra"
        titulo="Página não encontrada"
        descricao="O endereço acessado não existe no AgriGest."
        acao={{ to: '/', label: 'Voltar para o início' }}
      />
    </div>
  );
}
